
export default function setup() {
    $(document).ready(function () {
        $('#removeBoatButton').on('click', function () {
            const salePrice = $('#SalePrice').val();
            const saleDate = $('#SaleDate').val();
            // Collect the form data
            var formData = $('#removeBoatForm').serialize();
            if (salePrice == '' || saleDate == '') {                
                GetModalWindow(formData);
            }
            else {
                MarkBoatAsSold(formData);
            }
        });

        function MarkBoatAsSold(formData)
        {
            // Send the form via AJAX
            $.ajax({
                url: '/RemoveBoat/MarkBoatAsSoldJs',  // The action method that handles the form submission
                type: 'POST',
                data: formData,
                success: function (response) {
                    // If success, perform the redirect
                    window.location.href = response.redirectUrl;
                },
                error: function (xhr, status, error) {
                    // Handle errors (e.g., validation issues)
                    console.log("Error occurred: " + error);
                }
            });
        }

        function GetModalWindow(formData) {
            $.ajaxSetup({ cache: false });

            // Send the form via AJAX
            $.ajax({
                url: '/RemoveBoat/GetSaleBoatModalWindow',  // The action method that handles the form submission
                type: 'POST',
                data: formData,
                success: function (response) {
                    $('#dialogContent').html(response);
                    $('#modalWindowDialog').modal('show');
                },
                error: function (xhr, status, error) {
                    // Handle errors (e.g., validation issues)
                    console.log("Error occurred: " + error);
                }
            });
        }  

        function showError(container, errorMessage) {
            container.className = 'error';
            var msgElem = document.createElement('span');
            msgElem.className = "error-message";
            msgElem.innerHTML = errorMessage;
            container.appendChild(msgElem);
        }

        function resetError(container) {
            container.className = '';
            if (container.lastChild.className == "error-message") {
                container.removeChild(container.lastChild);
            }
        }

        //function IsValidSoldData(soldPrice, soldDate)
        //{
        //    var elems = form.elements;
        //    resetError(elems.SalePrice.parentNode);
        //    if (!elems.sumPay.value) {
        //        showError(elems.SalePrice.parentNode, ' Укажите Сумму(разделитель . или ,)');
        //    }
        //    if (soldPrice)
        //    {
        //        if (soldDate) {
        //            return true;
        //        }
        //        else {

        //        }

        //    }
        //}
    });
}